import * as reactComponents from "./react-components.js";
import store from "./redux/store.js";
import actions from "./redux/actions.js";
window.oldReactComponent = reactComponents;
window.oldReduxStore = store;
window.oldReduxActions = actions;
